module.exports = __webpack_public_path__ + "media/acute gastritis.13d549d2.wav";